import LegalPage from './LegalPage'
import { PRIVACY_POLICY } from './legal'

export default function PrivacyPolicyPage() {
  return <LegalPage {...PRIVACY_POLICY} />
}
